var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.442,
    height: 46.318,
    viewBox: "0 0 55.442 46.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.159,62.765a1.155,1.155,0,0,0-.652,1.5,20.33,20.33,0,1,1-4.137-6.5,1.155,1.155,0,1,0,1.679-1.587,22.48,22.48,0,1,0,4.607,7.239A1.155,1.155,0,0,0,42.159,62.765Z",
    transform: "translate(0 -47.985)",
    fill: "#d2a825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.446,112.455a1.155,1.155,0,0,0-.04-1.633,16,16,0,1,0,4.207,6.744,1.155,1.155,0,0,0-2.2.7,13.537,13.537,0,0,1,.638,4.122,13.672,13.672,0,1,1-4.236-9.895A1.155,1.155,0,0,0,84.446,112.455Z",
    transform: "translate(-50.762 -98.679)",
    fill: "#d2a825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.052,162.624a7.421,7.421,0,0,1,3.931,1.118,6.31,6.31,0,0,1,.523.361,1.155,1.155,0,1,0,1.41-1.83,8.649,8.649,0,0,0-.713-.492,9.771,9.771,0,1,0,4.523,6.977,1.155,1.155,0,1,0-2.289.311,7.358,7.358,0,0,1,.069,1,7.446,7.446,0,1,1-7.454-7.447Z",
    transform: "translate(-98.448 -146.359)",
    fill: "#d2a825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.751,48.757l-4.714-2.819-.565-5.406a1.155,1.155,0,0,0-1.774-.851l-4.537,2.92a1.155,1.155,0,0,0-.53.956l-.081,6L172.255,60.667a3.175,3.175,0,0,0-1.868-.606,3.2,3.2,0,1,0,3.129,2.543l18.372-11.158,5.264,2.277a1.155,1.155,0,0,0,1.082-.088l4.548-2.915a1.155,1.155,0,0,0-.03-1.964Zm-5.247,2.6-4.642-2.007.07-5.144,2.437-1.568.43,4.113a1.155,1.155,0,0,0,.556.871l3.609,2.158Z",
    transform: "translate(-147.871 -39.497)",
    fill: "#d2a825"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.5d1d3deb4df039a8185d85ba116dfa63.svg";
export { ForwardRef as ReactComponent };